import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		//formState
		errors,
		isSubmitting,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		setLoading,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<form
			className="form"
			onSubmit={handleSubmit(
				handleOnSubmit,
				// handleOnError
			)}
		>
			<main>
				<div className="row">
					<TextInput
						label="Categoria"
						id="nome"
						placeholder=""
						register={register}
						errors={errors}
						onKeyDown={libForm.EnterTab}
						autoFocus={true}
						className="col-12"
					/>
					<TextInput
						label="Observação"
						id="obs"
						placeholder=""
						register={register}
						errors={errors}
						onKeyDown={libForm.EnterTab}
						className="col-12"
					/>
					<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-4">
						<label htmlFor="">Aonde se Encaixa</label>
						<select {...register("tipo")} defaultValue="" onKeyDown={(e) => libForm.EnterTab(e)}>
							<option value="" disabled hidden>
								Selecione uma opção
							</option>
							<option value="E">Conta Entrada</option>
							<option value="S">Conta Saída</option>
							<option value="T">Todos</option>
						</select>
						{errors.tipo && <p className="errors">{errors.tipo.message}</p>}
					</div>
					<div className={`check-box col-12 col-sm-12`}>
						<div className="check-input">
							<input
								className={`${errors.ativo ? "error" : ""}`}
								id="ativo_categoria"
								type="checkbox"
								{...register("ativo")}
								autoComplete="off"
							/>
							<label htmlFor="ativo_categoria">
								<span className="text-lg">Ativar Categoria</span>
							</label>
						</div>
					</div>
				</div>
			</main>
			<footer>
				<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
				<BtnSubmit isSubmitting={isSubmitting} />
			</footer>
		</form>
	);
};

export default Form;
